/******************************* 公共接口 *******************************/
import request from "@/utils/request";
import { Notification } from "element-ui";
import { queryString } from "@/utils/tools";
import {tokenName} from "@/config/net.config"
/**
 *@desc 导出数据 有参数
 *@author wsx
 *@date 2022-11-07 16:42:38
 */
export function downloadFileData(data, url, method) {
  const query =
    method === "post"
      ? {
          url: url,
          method,
          data: data,
          responseType: "blob",
        }
      : {
          url: url + queryString(data),
          method,
          // params: queryString(data),
          responseType: "blob",
        };
  return request(query).then((res) => {
    if (res) {
      return res;
    } else {
      Notification.error({
        title: "错误",
        message: res.message,
      });
    }
  });
}

/**
 *@desc 数据权限树 组织类型(1教学院系2科研机构3公共服务4党务部门5行政机构6附属单位7后勤部门8校办产业9其他10校区11专业12班级13全校)
 *@author wsx
 *@date 2022-11-08 14:03:13
 */
export function queryDeptTree(data) {
  return request({
    url: "/upms/dept/api/tree/list",
    method: "post",
    data,
  });
}

/**
 *@desc 年份下拉
 *@author wsx
 *@date 2022-11-08 14:19:24
 */
export function queryYearList(data) {
  return request({
    url: `/upms/clazz/year/list`,
    method: "post",
    data,
  });
}

/**
 *@desc 学年下拉
 *@author wsx
 *@date 2022-11-08 14:19:24
 */
export function upmsTermOpenApi() {
  return request({
    url: "/upms/term/select/list",
    method: "post",
  });
}

/**
 *@desc 导入结果-错误数据导出
 *@author wsx
 *@date 2022-11-09 14:50:58
 */
export function importResultExport(data) {
  return request({
    url: `/upms/init/export/collect`,
    method: "post",
    data,
  });
}

/**
 *@desc 级联查询组织架构树
 *@id 岗位id，如果传递该参数会走数据权限验证，否则不走数据权限验证
 *@types 组织类型(1教学院系2科研机构3公共服务4党务部门5行政机构6附属单位7后勤部门8校办产业9其他10校区11专业12班级13全校)
 *@list 组织id集合，查询直属子级部门
 */
export function getOrgTree(data) {
  return request({
    url: "/upms/dept/api/tree/list",
    method: "post",
    data,
  });
}

/**
 *@desc 组织架构树
 *@author wsx
 *@date 2022-11-15 17:23:55
 */
export function getTreeByTypes(data) {
  return request({
    url: "/upms/org/types/tree",
    method: "post",
    data,
  });
}

/**
 *@desc 岗位下拉列表
 *@author wsx
 *@date 2022-11-16 10:45:43
 */
export function getPostList(data) {
  return request({
    url: "/upms/post/down/list",
    method: "post",
    data,
  });
}

/******************************* 文档服务模块：文档信息 *******************************/
// 上传验证
export function checkUpload(data) {
  return request({
    url: `/dms/file/upload/check`,
    method: "post",
    data: {
      key: "4",
      parent: "0",
      type: 4,
      size: data.size, // 文件体积，单位byte
      suffix: data.suffix, // 文档后缀(带点)
      relativePath: data.relativePath, // 文件夹上传的时候文件的相对路径属性（包括最后一个文件及其后缀）
    },
  });
}

// 上传合并
export function mergeUpload(data) {
  return request({
    url: `/dms/file/upload/merge`,
    method: "post",
    data: {
      key: "4",
      parent: "0", // 所属父级主键
      type: 4,
      totalSize: data.totalSize, // 文件总大小
      filename: data.filename,
      identifier: data.identifier, // 文件唯一标识
      relativePath: data.relativePath, // 文件夹上传的时候文件的相对路径属性（包括最后一个文件及其后缀）
    },
  });
}

// 下载
export function downloadPartialFile(data, fileName) {
  const formData = new FormData();
  formData.append("key", "4");
  formData.append("parent", "0");
  formData.append("type", "4");
  formData.append("list", data.list);
  formData.append("name", data.name);
  return request({
    url: `/dms/file/download`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData,
    responseType: "blob",
  }).then((res) => {
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      if (res.type === "application/json") {
        const jsonRes = JSON.parse(fileReader.result);
        if (jsonRes.code !== 1) {
          Notification.error({
            title: "错误",
            message: jsonRes.message || "导出异常！",
          });
          return false;
        }
      } else {
        // 将二进制流转为blob
        const blob = new Blob([res]);
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(fileName));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(fileName));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
        }
      }
    };
    fileReader.readAsText(res);
  });
}
export function downloadFile(item) {
  const link = document.createElement("a");

  const formData = new FormData();
  formData.append("type", "4");
  formData.append("key", "4");
  formData.append("parent", "0");
  formData.append("name", item.name);
  formData.append("list", [item.id]); // 发送POST请求
  fetch("/api/dms/file/download", {
    method: "POST",
    headers: {
      token: localStorage.getItem(tokenName),
    },
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.blob();
    })
    .then((blob) => {
      // 创建 Blob 对象
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));
      link.href = blobUrl;
      link.download = item.name; // 设置 download 属性以提示浏览器下载文件
      link.style.display = "none"; // 隐藏链接 // 将链接添加到 DOM 中
      document.body.appendChild(link); // 触发点击事件
      link.click(); // 清理资源
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
